import { privateHttp } from "@/shared/http/private-http";
import type {
    RecoveryChannelsResponse,
    RequestRecoveryCodeDto,
    RequestRecoveryCodeResult,
    ResetPasswordDto,
    ResetPasswordResult,
    VerifyRecoveryCodeDto,
    VerifyRecoveryCodeResult,
} from "../types/password-recovery.dto";

/**
 * Recuperação de senha ("esqueci minha senha") — três passos na nest:
 * pedir o código, verificar, redefinir.
 *
 * Vai por `privateHttp` (não `publicGet`) mesmo sendo rota pública: são
 * MUTAÇÕES e a resposta é específica de quem pediu — nada aqui pode ser
 * cacheado nem compartilhado entre visitantes (ver `public-http.ts`).
 */

/** GET /auth/password/channels — quais métodos de envio a loja tem ligados. */
export async function getRecoveryChannels(): Promise<RecoveryChannelsResponse> {
    const { data } = await privateHttp.get<RecoveryChannelsResponse>("/auth/password/channels");
    return data;
}

/** POST /auth/password/forgot — envia o código pelo canal escolhido. */
export async function requestRecoveryCode(
    payload: RequestRecoveryCodeDto
): Promise<RequestRecoveryCodeResult> {
    const { data } = await privateHttp.post<RequestRecoveryCodeResult>(
        "/auth/password/forgot",
        payload
    );
    return data;
}

/** POST /auth/password/verify-code — troca o código pelo token de redefinição. */
export async function verifyRecoveryCode(
    payload: VerifyRecoveryCodeDto
): Promise<VerifyRecoveryCodeResult> {
    const { data } = await privateHttp.post<VerifyRecoveryCodeResult>(
        "/auth/password/verify-code",
        payload
    );
    return data;
}

/** POST /auth/password/reset — grava a nova senha com o token de redefinição. */
export async function resetPassword(payload: ResetPasswordDto): Promise<ResetPasswordResult> {
    const { data } = await privateHttp.post<ResetPasswordResult>("/auth/password/reset", payload);
    return data;
}
